
import apiClient from '../../clients/api-client';

export enum Tabs {
  dashboard = 'dashboard',
  library = 'library',
  collections = 'collections',
  academy = 'academy',
  hub = 'hub',
  learners = 'learners',
  learnerGroup = 'learner_group',
  integrations = 'integrations',
  trash = 'trash',
  emails = 'emails',
  embeds = 'embeds'
}
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import TButton from '@/lib/form/button/Button.vue';
import { Watch } from 'vue-property-decorator';
import { AuthService } from '@/app/services/auth-service';
import { EditorFlow } from '@/lib/utils/editor-type';
// import TrainnWidget from '@/lib/widget';
import AcademyMixin from '@/app/player/mixins/AcademyMixin';
import DashboardIcon from '@/app/components/icons/Dashboard.vue';
import LibraryIcon from '@/app/components/icons/Library.vue';
import ChevronRightIcon from '@/app/components/icons/ChevronRight.vue';
import ChevronTopIcon from '@/app/components/icons/ChevronTop.vue';
import InAppTutorialsIcon from '@/app/components/icons/InAppTutorials.vue';
import CollectionIcon from '@/app/components/icons/Collection.vue';
import HubIcon from '@/app/components/icons/Hub.vue';
import AcademyIcon from '@/app/components/icons/Academy.vue';
import UserGroupIcon from '@/app/components/icons/UserGroup.vue';
import UserIcon from '@/app/components/icons/User.vue';
import EmailIcon from '@/app/components/icons/Email.vue';
import IntegrationIcon from '@/app/components/icons/Integrations.vue';
import VideoIcon from '@/app/components/icons/Video.vue';
import GuideIcon from '@/app/components/icons/Guide.vue';
import ArticleIcon from '@/app/components/icons/Article.vue';
import DocumentIcon from '@/app/components/icons/Document.vue';

declare let PARTNER_MODE: boolean;
declare let PARTNER_ID: string;

@Component({
  name: 't-nav',
  components: {
    TButton,
    DashboardIcon,
    LibraryIcon,
    ChevronRightIcon,
    ChevronTopIcon,
    InAppTutorialsIcon,
    CollectionIcon,
    HubIcon,
    AcademyIcon,
    UserGroupIcon,
    UserIcon,
    EmailIcon,
    IntegrationIcon,
    VideoIcon,
    GuideIcon,
    ArticleIcon,
    DocumentIcon
  },
  props: ['message']
})
export default class TrainnNav extends mixins(AcademyMixin) {
  private currentTab = Tabs.dashboard;
  private tabs;
  private subTab = '';
  private logoutLoader = false;
  private expandLibrary = false;
  private showAcademySubTab = false;
  private showVideoHubSubTab = false;
  private partnerMode = PARTNER_MODE;
  private partnerId = PARTNER_ID;
  // private widget: any = TrainnWidget({ siteName: 'wiki' });
  private rootFolderId = '';
  private showMenu = false;
  private folderId;
  private loading = false;
  private showEmbedSubTab = false;

  beforeCreate() {
    this.tabs = Tabs;
  }

  created() {
    this.currentTab = this.$route.meta && this.$route.meta.tab;
    this.subTab = this.$route.meta && this.$route.meta.subTab;
    this.expandLibrary = this.currentTab == Tabs.library;
    this.showAcademySubTab = this.currentTab == Tabs.academy;
    this.showEmbedSubTab = this.currentTab == Tabs.embeds;

    this.$root.$on('update-root-folder-id', this.updateRootFolderId);
    this.folderId =
      this.$route.params.folderId || this.$user.state.workspace.rootFolderId;
    window.addEventListener('click', this.hideMenu);
  }

  @Watch('$route')
  onRouteChange(to, from) {
    this.currentTab = to.meta && to.meta.tab;
    this.subTab = this.$route.meta && this.$route.meta.subTab;
    this.expandLibrary = this.currentTab == Tabs.library;
    this.showAcademySubTab = this.currentTab == Tabs.academy;
    this.showEmbedSubTab = this.currentTab == Tabs.embeds;
  }

  get profile() {
    return this.$user && this.$user.state.profile;
  }

  get isTrial() {
    return this.$user.subscription.status == 'in_trial';
  }

  get initials() {
    if (this.$isEmpty(this.profile)) {
      return;
    }
    if (this.profile.fullName) {
      return this.profile.fullName.charAt(0);
    } else if (this.profile.email) {
      return this.profile.email.charAt(0);
    }
  }

  get onBoardingTasks() {
    return this.$user && this.$user.onBoardingTasks;
  }

  get completeCount() {
    if (this.$isEmpty(this.onBoardingTasks)) {
      return 0;
    }
    return Object.keys(this.onBoardingTasks).filter(
      t => this.onBoardingTasks[t].completed
    ).length;
  }

  get completionPercentage() {
    return ((this.completeCount / 6) * 100).toFixed(0) + '%';
  }

  get workspace() {
    return this.$user.workspace;
  }

  get isTrainingEventsEnabled() {
    return (
      this.workspace &&
      this.workspace.configs &&
      this.workspace.configs.trainingEventsEnabled
    );
  }

  get canUpdateVideoHub() {
    return this.$user.can('update', 'video_hub_setting');
  }

  toggleVideoHub() {
    this.showVideoHubSubTab = !this.showVideoHubSubTab;
  }

  toggleAcademy() {
    if (this.$isMobile) return;
    this.showAcademySubTab = !this.showAcademySubTab;
  }

  toggleEmbed() {
    if (this.$isMobile) return;
    this.showEmbedSubTab = !this.showEmbedSubTab;
  }

  toggleLibrary() {
    if (this.$isMobile) return;
    this.expandLibrary = !this.expandLibrary;
  }

  manage() {
    this.$modal.show('manage-workspace');
  }

  openCreateModal() {
    if (this.canRedirectToRecordPage) {
      this.$router.push('/record');
      return;
    }
    this.$modal.show('create-video');
  }

  createInteractiveGuide() {
    this.$router.push(
      '/record_guide' +
        (this.$route.params.folderId
          ? `?folderId=${this.$route.params.folderId}`
          : '')
    );
  }

  openDocumentUploadModal() {
    this.$modal.show('add-document-modal');
  }

  createArticle() {
    this.loading = true;
    apiClient
      .createArticle(this.folderId)
      .then(data => {
        this.loading = false;
        this.$router.push(`/articles/${data.id}/edit`);
      })
      .catch(err => {
        this.loading = false;
        this.$error(err);
      });
  }

  updateRootFolderId(id) {
    this.rootFolderId = id;
  }

  get academyBuilderUrl() {
    if (!(this.isAcademyEnabledForWorkspace && this.isAcademyEnabled)) {
      return '/academy';
    } else {
      return {
        name: 'academy_builder',
        params: { pageName: 'login-default' }
      };
    }
  }

  get editorFlowConfig() {
    return this?.$user?.workspace?.configs?.v2EditorFlow;
  }

  get canRedirectToRecordPage() {
    const editorTypeArray = Object.keys(EditorFlow).map(key => EditorFlow[key]);

    return (
      editorTypeArray.includes(this.editorFlowConfig) &&
      this.editorFlowConfig === EditorFlow.STRICTLY_ENABLED
    );
  }

  get appEmbedsEnabled() {
    return (
      this.workspace &&
      this.workspace.configs &&
      this.workspace.configs.appEmbedsEnabled
    );
  }

  logout() {
    this.logoutLoader = true;
    AuthService.getInstance().logout();
  }

  openLearningCenter() {
    window.Trainn('configure', {
      domainName: 'wiki',
      learner: {
        email: this.$user.state.profile.email
      },
      learnerHash: this.$user.state.learnerHash
    });
    window.Trainn('open');
    // if (this.$user.state.engagementToken) {
    //   this.widget.setUserToken(this.$user.state.engagementToken);
    // }
    // this.widget!.show();
  }

  hideMenu(event) {
    if (
      event &&
      event.target &&
      event.target.closest('.t-nav__create , .t-pos--rel , .t-pad--b-mi')
    ) {
      return;
    }
    this.showMenu = false;
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  destroyed() {
    this.$root.$off('update-root-folder-id', this.updateRootFolderId);
  }
}
